// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const selfIncrementingProgressbar = "SelfIncrementingProgressbar__selfIncrementingProgressbar__-7ftZ";
export const large = "SelfIncrementingProgressbar__large__3vJx-";
export const progressPercentage = "SelfIncrementingProgressbar__progressPercentage__3fmbZ";
export const progressLineWrapper = "SelfIncrementingProgressbar__progressLineWrapper__evF2w";
export const progressLine = "SelfIncrementingProgressbar__progressLine__7fzd6";